import { create } from 'zustand';

export type SortOption = 'newest' | 'oldest' | 'alpha' | 'quickest';
export type ViewMode = 'all' | 'favorites' | 'quick-meals' | string; // string for collection IDs

export interface RecipeFilters {
  search: string;
  cuisine: string;
  season: string;
  recipeType: string;
  difficulty: string;
  maxPrepTime: string;
  sort: SortOption;
}

interface FilterState {
  filters: RecipeFilters;
  viewMode: ViewMode;
  viewStyle: 'grid' | 'list';
}

interface FilterActions {
  setFilter: <K extends keyof RecipeFilters>(key: K, value: RecipeFilters[K]) => void;
  setFilters: (filters: Partial<RecipeFilters>) => void;
  clearFilters: () => void;
  setViewMode: (mode: ViewMode) => void;
  setViewStyle: (style: 'grid' | 'list') => void;
}

type FilterStore = FilterState & FilterActions;

const defaultFilters: RecipeFilters = {
  search: '',
  cuisine: '',
  season: '',
  recipeType: '',
  difficulty: '',
  maxPrepTime: '',
  sort: 'newest',
};

export const useFilterStore = create<FilterStore>()(set => ({
  // Initial state
  filters: { ...defaultFilters },
  viewMode: 'all',
  viewStyle: 'grid',

  // Actions
  setFilter: (key, value) =>
    set(state => ({
      filters: { ...state.filters, [key]: value },
    })),

  setFilters: filters =>
    set(state => ({
      filters: { ...state.filters, ...filters },
    })),

  clearFilters: () =>
    set({
      filters: { ...defaultFilters },
    }),

  setViewMode: mode => set({ viewMode: mode }),
  setViewStyle: style => set({ viewStyle: style }),
}));
